import { Controller } from '@hotwired/stimulus'

// The Active Admin filters sidebar section. Hidden by default (see active_admin.css)
// and shown/hidden when the page-header button dispatches admin-filters-toggle:toggle.
export default class extends Controller {
  toggle() {
    this.element.classList.toggle('is-open')
  }
}
